import { createSelector, Selector } from '@reduxjs/toolkit';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { IndoorSpace } from '../../../models/spaceModels';
import { Store } from '../../../reducers';

type CustomThresholds = {
    name: string;
    id: string;
    sensors: SensorTypes[];
};
const selectSpaceCustomThresholds = (state: Store, buildingId: string): CustomThresholds[] => {
    const locationSpaces = state.spaces.spaces[buildingId];
    const spacesWithCustomThresholds = locationSpaces?.spaces.filter(
        space => !!(space as IndoorSpace).customThresholds
    );
    return (
        spacesWithCustomThresholds
            ?.map(space => {
                const customThresholds = (space as IndoorSpace).customThresholds || {};
                const sensorKeys = Object.keys(customThresholds).map(sensor => sensor as SensorTypes);
                return {
                    name: space.name,
                    id: space.id,
                    sensors: sensorKeys,
                };
            })
            .filter(item => item.sensors.length > 0) ?? []
    );
};

const makeCustomThresholdSelector = (buildingId: string): Selector<Store, CustomThresholds[]> =>
    createSelector(
        [(state: Store): CustomThresholds[] => selectSpaceCustomThresholds(state, buildingId)],
        (customThresholds: CustomThresholds[]) => customThresholds
    );

export { makeCustomThresholdSelector, selectSpaceCustomThresholds };
